export default "__VITE_ASSET__Zp9P4fVY__"